const MONTH_ABBREVIATIONS_ES = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sep',
  'Oct',
  'Nov',
  'Dic',
] as const;

const MONTH_ABBREVIATIONS_EN = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

export function formatSlotTime12h(timeFrom?: string): string {
  if (!timeFrom) {
    return '9:00 AM';
  }

  const match = timeFrom.trim().match(/^(\d{1,2}):(\d{2})/);
  if (!match) {
    return timeFrom;
  }

  const hour24 = Number(match[1]);
  const minutes = match[2];

  if (!Number.isFinite(hour24)) {
    return timeFrom;
  }

  const period = hour24 >= 12 ? 'PM' : 'AM';
  let hour12 = hour24 % 12;
  if (hour12 === 0) {
    hour12 = 12;
  }

  return `${hour12}:${minutes} ${period}`;
}

export function formatOvernightConfirmationDeadline(
  collectionDate?: string | null,
  slotTimeFrom?: string,
  lang: string = 'es',
): string {
  if (!collectionDate) {
    return '';
  }

  const [year, month, day] = collectionDate.split('-').map(Number);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return '';
  }

  const monthAbbreviations = lang.startsWith('en')
    ? MONTH_ABBREVIATIONS_EN
    : MONTH_ABBREVIATIONS_ES;
  const monthLabel = monthAbbreviations[month - 1] ?? '';
  const yearShort = String(year).slice(-2);
  const timeLabel = formatSlotTime12h(slotTimeFrom);

  return `${timeLabel} del ${day}/${monthLabel}/${yearShort}`;
}
